import { Link } from 'react-router-dom';

const cases = [
  {
    icon: 'ri-ship-line',
    title: 'Международная логистическая компания',
    metrics: [
      { value: '18–23%', label: 'рост конверсии' },
    ],
    link: '/prodazhi-i-peregovory/trening-po-peregovoram',
    linkLabel: 'Посмотреть программу',
  },
  {
    icon: 'ri-shopping-cart-2-line',
    title: 'B2C — продажи товаров из Китая',
    metrics: [
      { value: '55%', label: 'рост конверсии' },
      { value: '116 000 $', label: 'рост валовой прибыли' },
    ],
    link: '/prodazhi-i-peregovory/trening-po-prodazham',
    linkLabel: 'Посмотреть программу',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Israel Assist — консьерж-сервис',
    metrics: [
      { value: '64% → 84%', label: 'рост продлений' },
      { value: '×9', label: 'рост длительных оплат' },
    ],
    link: '/prodazhi-i-peregovory/trening-po-rabote-s-klientami',
    linkLabel: 'Посмотреть программу',
  },
  {
    icon: 'ri-home-4-line',
    title: 'Агентство недвижимости',
    metrics: [
      { value: '×2', label: 'рост договоров после обучения холодным звонкам' },
    ],
    link: '/prodazhi-i-peregovory/trening-po-holodnym-zvonkam',
    linkLabel: 'Посмотреть программу',
  },
];

export default function CompanyResults() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Какие результаты получают компании
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto">
          Реальные результаты <Link to="/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh" className="text-teal-600 hover:text-teal-700 underline">корпоративного обучения продажам</Link> — цифры, подтверждённые бизнес-показателями
        </p>

        <div className="space-y-5 max-w-4xl mx-auto">
          {cases.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-5 md:p-6 border border-gray-100 hover:shadow-lg transition-all group">
              <div className="flex flex-col sm:flex-row sm:items-center gap-4 md:gap-6">
                <div className="flex items-center gap-4 flex-1">
                  <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-xl text-white`}></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 text-sm md:text-base mb-2">{item.title}</h3>
                    <div className="flex flex-wrap gap-3 md:gap-6">
                      {item.metrics.map((m, j) => (
                        <div key={j}>
                          <span className="text-teal-600 font-extrabold text-lg md:text-xl">{m.value}</span>
                          <span className="text-gray-500 text-xs ml-1">{m.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <Link
                  to={item.link}
                  className="bg-teal-600 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-1.5 flex-shrink-0"
                >
                  {item.linkLabel}
                  <i className="ri-arrow-right-line text-xs"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10 bg-teal-50 rounded-2xl p-6 max-w-3xl mx-auto">
          <p className="text-gray-700 text-sm md:text-base leading-relaxed">
            Во всех проектах большое внимание уделялось именно качеству коммуникации сотрудников с клиентами и системному подходу к <Link to="/prodazhi-i-peregovory/trening-po-peregovoram" className="text-teal-600 hover:text-teal-700 underline font-medium">обучению переговорам</Link>.
          </p>
        </div>
      </div>
    </section>
  );
}